import React from "react";
import styled from "styled-components";

// Components
//import SubscriptionInput from "../../Navgation/SubscriptionInput/SubscriptionInput";
import NavigationItem from "./NavigationItem/NavigationItem";
import Divider from "../../Divider/Divider";
//import Newsletter from "../../Newsletter/Newsletter";

const Nav = styled.div`
  display: flex;
  flex: 0 0 92%;
  justify-content: space-between;
  box-sizing: border-box;

  @media (max-width: 699px) {
    flex-direction: column;
  }
`;

const NavbarItems = styled.nav`
  display: flex;
  align-items: baseline;
  //flex: 1 1 70vw;
  justify-content: space-between;
  padding-left: 2rem;

  @media (max-width: 699px) {
    flex-direction: column;
  }
`;

const StyledDivider = styled(Divider)`
  @media (max-width: 700px) {
    display: none;
  }
`;
const NavigationItems = ({ className, props }) => {
  return (
    <Nav className={className}>
      <NavbarItems>
        <NavigationItem link="/vision">Vision</NavigationItem>
        <StyledDivider>|</StyledDivider>
        <NavigationItem link="/concept">Concept</NavigationItem>
        <StyledDivider>|</StyledDivider>
        <NavigationItem link="/progress">Progress</NavigationItem>
        {/*<NavigationItem link="/audition">Audition</NavigationItem>*/}
        {/*<StyledDivider>|</StyledDivider>*/}
        {/*<NavigationItem link="/prints">Print Gallery</NavigationItem>*/}
      </NavbarItems>
      {/*<SubscriptionInput />*/}
      {/*<Newsletter />*/}
    </Nav>
  );
};

export default NavigationItems;



// WEBPACK FOOTER //
// ./src/components/Navgation/NavigationItems/NavigationItems.js